import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { EYapePromotionSearchMethod } from 'core/model/enums/yape.enum';
import { IYapeState } from './types';

export const SLICE_NAMESPACE = 'yape';

export const initialState: IYapeState = {
  promo: {
    filters: {},
    searchMethod: EYapePromotionSearchMethod.NAME,
    list: {
      data: [],
      isLoading: false,
      pagination: DEFAULT_PAGINATION,
    },
    form: {
      success: false,
      loading: false,
      errors: {},
    },
  },
  qr: {
    filters: {},
    list: {
      data: [],
      isLoading: false,
      pagination: DEFAULT_PAGINATION,
    },
  },
};
